import * as React from "react";
const SvgArrowLineDown20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M9 3h2v10.172l2.422-2.423 1.415 1.414L10 17l-4.837-4.837 1.415-1.414L9 13.172V3Z"
    })
  );
export default SvgArrowLineDown20Px;
